<p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" key="filestoreToast"></p-toast>
<p-confirmDialog />
<div class="flex-1 relative">
    <div class="absolute w-full h-full">
        <p-table [value]="filesInCurrentFolder" [scrollable]="true" scrollHeight="flex" [loading]="loading" #fileTable
            [expandedRowKeys]="expandedRowKey" [globalFilterFields]="['name','displayName', 'createdBy', 'lastModifiedBy']"
            class="filestore-table" selectionMode="multiple" dataKey="id" [(selection)]="selectedFiles" (selectionChange)="onSelcectionChange()">
            <ng-template #caption>
                <p-breadcrumb class="max-w-full" [model]="currentFolderHierachy" [home]="home"
                    *ngIf="!searchModeEnabled">
                    <ng-template pTemplate="item" let-item>
                        <span class="cursor-pointer" (click)="changeFolder(item.data)">
                            {{item.title}}
                        </span>
                    </ng-template>
                    <ng-template #seperator> / </ng-template>
                </p-breadcrumb>
                <p-message severity="error" styleClass="mt-3"
                    *ngIf="selectionOptions && selectedFiles?.length>0 && validateFileSelection()!=null">
                        {{validateFileSelection()}}
                </p-message>

                <p-toolbar *ngIf="!searchModeEnabled">
                    <div class="p-toolbar-group-start">
                        <p-button icon="far fa-file-check" class="mr-2" *ngIf="selectionOptions"
                        label="Select" i18n-label="@@filestore-browser-selection-select"
                        (onClick)="onAcceptSelection()" severity="secondary"
                        [disabled]="validateFileSelection()!=null"></p-button>

                        <p-button icon="far fa-chevron-left" class="mr-2" *ngIf="_currentFolder"
                            (onClick)="onNavigateFolderUp()" severity="secondary"></p-button>
                        <p-button icon="fas fa-cloud-arrow-down" class="mr-2" *ngIf="isDownloadableSelection()"
                            (onClick)="onDownloadFiles()" severity="secondary"></p-button>
                        <p-button icon="fas fa-cloud-arrow-up" class="mr-2" *ngIf="canAddFiles()"
                            (onClick)="openUploadDialog()" severity="secondary"></p-button>

                        <p-menu #topLevelActionMenu [model]="topLevelMenuOptions" [popup]="true"
                            (onShow)="evalTopLevelMenuOptions()" appendTo="body" />
                        <p-button icon="far fa-list-check" class="mr-2" (onClick)="onToggleSelection()"
                            [styleClass]="enabledSelection?'surface-700':''" severity="secondary"></p-button>
                        <p-button (onClick)="topLevelActionMenu.toggle($event)" icon="far fa-ellipsis" class="mr-2"
                            *ngIf="fileStore?.writeAccess" severity="secondary" />
                    </div>
                    <div class="p-toolbar-group-end">
                        <p-menu #sortMenu [model]="sortOptions" [popup]="true" appendTo="body" />
                        <p-button (onClick)="sortMenu.toggle($event)" icon="far fa-arrow-up-arrow-down"
                            severity="secondary" [text]="true" />
                        <p-button icon="far fa-magnifying-glass" (onClick)="onOpenSearch()" severity="secondary"
                            [text]="true"></p-button>
                    </div>
                </p-toolbar>
                <!--SEARCH bar-->
                <p-toolbar *ngIf="searchModeEnabled">

                    <div class="flex flex-1 flex-row"  id="searchBarContainer">
                        <span class="p-input-icon-left w-full relative">
                            <i class="pl-2 far fa-magnifying-glass absolute top-0 bottom-0 m-auto" style="height: fit-content"></i>
                            <input type="text" class="w-full" pInputText id="searchBar"
                                   (input)="fileTable.filterGlobal($event.target['value'], 'contains')" />
                        </span>
                    </div>
<!--                    <div class="p-toolbar-group-start">-->
<!--                        <span class="p-input-icon-left">-->
<!--                            <i class="far fa-magnifying-glass"></i>-->
<!--                            <input pInputText type="text"-->
<!--                                (input)="" placeholder="Suche"-->
<!--                                i18n-placeholder="@@filestore-operation-log.search" style="width:100%" />-->
<!--                        </span>-->
<!--                    </div>-->
                    <div class="p-toolbar-group-end">
                        <p-button icon="far fa-times" [text]="true" (onClick)="onCloseSearch()"
                            severity="secondary"></p-button>
                    </div>
                </p-toolbar>

            </ng-template>
            <ng-template #header>
                <tr [class.hidden]="!enabledSelection">
                    <th style="width: 3rem" *ngIf="enabledSelection"><p-tableHeaderCheckbox #isAllSelectedCheckbox />
                    </th>
                    <th class="custom-width-th">
                        <span *ngIf="isAllSelectedCheckbox && isAllSelectedCheckbox.checked"
                            i18n="@@filestore-browser.deselectall">Deselect all</span>
                        <span *ngIf="!isAllSelectedCheckbox || !isAllSelectedCheckbox.checked"
                            i18n="@@filestore-browser.selectall">Select all</span>
                    </th>
                    <th></th>
                    <th style="width:2rem"></th>
                </tr>
            </ng-template>
            <ng-template #body let-file let-index="rowIndex" let-expanded="expanded">

                <tr (press)="onPrepareContextMenu(file,$event['srcEvent'])" [class.selectionDisabled]="enabledSelection && !isFileReady(file)"
                    (contextmenu)="onPrepareContextMenu(file,$event)" (click)="onFileDoubleClicked(file)">
                    <td *ngIf="enabledSelection">
                        <p-tableCheckbox [value]="file" (click)="$event.stopPropagation();" />
                    </td>
                    <td class="icon text-center">
                        @if(isFileReady(file)){
                            <i class="fa-solid fa-folder text-xl" *ngIf="file.directory"></i>
                            @if(file.thumbnailImageUrl){
                                <div class="fileThumbnail relative flex justify-content-center align-items-center">
                                    <img class="fileThumbnail" [src]="file.thumbnailImageUrl">
                                    <i *ngIf="file.contentType.includes('video')" class="fas fa-circle-play fa-2xl videoImagePreviewIcon"></i>
                                </div>
                            }@else{
                                <i [class]="getFileIcon(file.contentType)" *ngIf="!file.directory"></i>
                            }
                        }
                        @else{
                            <div class="flex justify-content-center align-items-center">
                                <p-progressSpinner [style]="{'width': '2rem'}"></p-progressSpinner>
                            </div>
                        }
                    </td>
                    <td class="file-browser-border-bottom pl-0 py-2">
                        <div>
                            <div class="font-semibold text-lg" [class.pb-1]="file.directory"
                                style="word-break:break-all">{{ file.displayName }}</div>
                            <div *ngIf="!expanded && !file.directory" class="mt-2 text-sm">
                                {{ file.lastModified | date:'short' }} {{file.contentLength|
                                formatFileSize:false}}
                            </div>
                        </div>
                    </td>
                    <td class="text-right">
                        <p-button type="button" [text]="true" [rounded]="true" [plain]="true" [pRowToggler]="file"
                            (click)="$event.stopPropagation();"
                            [icon]="expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" />
                    </td>
                </tr>

                <tr>
                    <td *ngIf="!expanded" class="spacer-row" [colSpan]="3"></td>
                </tr>

            </ng-template>
            <ng-template #expandedrow  let-file>
                <tr>
                    <td colspan="4">
                        <div *ngIf="file.thumbnailImageUrl" class="text-center pb-4">
                            @if(file.contentType.includes('video') && isFileReady(file)){
                                <app-vjs-player class="w-full"
                                                [options]="{sources:[{src:file.optimizedUrl, type:'video/mp4'}], poster:file.thumbnailImageUrl,autoplay:false, aspectRatio:'16:9'}">
                                </app-vjs-player>
                            }@else{
                                <img [src]="file.thumbnailImageUrl" style="max-width: 100%;">
                            }
                        </div>
                        <div class="grid">
                            <div class="col-fixed" style="width:80px">
                                <label i18n="@@filestore-browser.details.filename">Filename:</label>
                            </div>
                            <div class="col">
                                <div>{{file.name}}</div>
                            </div>
                        </div>
                        <div class="grid" *ngIf="file.altText">
                            <div class="col-fixed" style="width:80px">
                                <label i18n="@@filestore-browser.details.altText">Alt. text:</label>
                            </div>
                            <div class="col">
                                <div>{{file.altText}}</div>
                            </div>
                        </div>
                        <div class="grid">
                            <div class="col-fixed" style="width:80px">
                                <label i18n="@@filestore-browser.details.created">Created:</label>
                            </div>
                            <div class="col">
                                <div>{{file.createdBy}}, {{file.created | date :'medium'}}</div>
                            </div>
                        </div>

                        <div class="grid">
                            <div class="col-fixed" style="width:80px">
                                <label i18n="@@filestore-browser.details.modified">Modified:</label>
                            </div>
                            <div class="col">
                                <div>{{file.lastModifiedBy}}, {{file.lastModified | date :'medium'}}</div>
                            </div>
                        </div>

                        <ng-container *ngIf="!file.directory">
                            <div class="grid">
                                <div class="col-fixed" style="width:80px">
                                    <label i18n="@@filestore-browser.details.size">Size:</label>
                                </div>
                                <div class="col">
                                    {{file.contentLength|
                                    formatFileSize:false}}
                                </div>
                            </div>
                        </ng-container>
                        <div class="text-right">
                              <p-button [text]="true" icon="far fa-cloud-arrow-down" (onClick)="onDownloadFiles(file)" *ngIf="!file.directory"
                                severity="secondary"></p-button>
                            <p-button [text]="true" icon="fa fa-ellipsis" (onClick)="onPrepareContextMenu(file,$event)"
                                severity="secondary"></p-button>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="spacer-row" [colSpan]="3"></td>
                </tr>
            </ng-template>
            <ng-template #summary>
                <div class="flex justify-content-center" *ngIf="fileStore?.writeAccess">
                    <div class="relative m-1 w-full lg:pb-4 lg:w-7 p-3"
                        *ngIf="usageStatistics && usageStatistics.storageUsedPercentage >= 90">
                        <p-progressBar [value]="getUsagePercentage()" [style]="{backgroundColor:'#8dc045'}"
                            [class.full]="usageStatistics.storageUsedPercentage >= 90">
                        </p-progressBar>
                        <div i18n="@@filestore-browser.storage.label"
                            class="absolute usageText text-sm mx-2 my-1 hidden lg:flex">
                            {{usageStatistics.storageUsedTotal | formatFileSize:false }} of
                            {{usageStatistics.storageQuota |
                            formatFileSize:false }} storage
                            used ({{usageStatistics.storageUsedPercentage}}%)
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #emptymessage>
                <tr>
                    <ng-container *ngIf="!searchModeEnabled">
                        <td colspan="3" i18n="@@filestore-table.empty-store" *ngIf="_currentFolder == null"
                            class="text-center font-semibold">There are no files
                            in
                            this store</td>
                        <td colspan="3" i18n="@@filestore-table.empty-directory" *ngIf="_currentFolder"
                            class="text-center font-semibold">There are no files this
                            directory</td>
                    </ng-container>
                    <ng-container *ngIf="searchModeEnabled">
                        <td colspan="3" i18n="@@filestore-table.empty-search-result" class="text-center font-semibold">
                            No files matching your search</td>
                    </ng-container>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>


<p-dialog [focusOnShow]="false" header="Create directory" i18n-header="@@filestore-table.dialog.createDirectory.title"
    [modal]="true" [(visible)]="dialogControl.createDirectory.visible" *ngIf="dialogControl.createDirectory.visible">
    <div class="flex flex-column gap-2 mt-2">
        <input pInputText aria-describedby="username-help" [(ngModel)]="dialogControl.createDirectory.name" />
        <small i18n="@@filestore-table.dialog.createDirectory.text" class="mt-1">
            Please enter the name of the directory
        </small>
    </div>
    <ng-template #footer>
        <div class="w-full flex justify-content-between ">
            <p-button (onClick)="dialogControl.createDirectory.name=null; dialogControl.createDirectory.visible=false"
                [severity]="'secondary'" label="Cancel"
                i18n-label="@@filestore-table.dialog.createDirectory.button.cancel" severity="secondary"></p-button>

            <div class="text-right">
                <p-button (onClick)="onCreateDirectory()" label="Create"
                    [disabled]="dialogControl.createDirectory.name == null || dialogControl.createDirectory.name.length == 0"
                    i18n-label="@@filestore-table.dialog.createDirectory.button.create" severity="secondary"></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<p-dialog [focusOnShow]="false" header="Rename" i18n-header="@@filestore-table.dialog.rename.title" [modal]="true"
    [style]="{ width: '25rem' }" [(visible)]="dialogControl.rename.visible" *ngIf="dialogControl.rename.visible">
    <div class="flex flex-column gap-2 mt-2">
        <input pInputText aria-describedby="username-help" [(ngModel)]="dialogControl.rename.file.name" />
        <small i18n="@@filestore-table.dialog.rename.text" class="mt-1">
            Please enter the new name
        </small>
    </div>
    <ng-template #footer>
        <div class="w-full flex justify-content-between">
            <div>
                <p-button (onClick)="dialogControl.rename.file = null; dialogControl.rename.visible=false"
                    label="Cancel" i18n-label="@@filestore-table.dialog.rename.button.cancel"
                    severity="secondary"></p-button>
            </div>
            <div class="text-right">
                <p-button (onClick)="onRenameFile()" label="Rename" [disabled]="!isFolderName(dialogControl.rename.file.name) && getFileEnding(dialogControl.rename.file.name) != dialogControl.rename.fileEnding"
                    i18n-label="@@filestore-table.dialog.rename.button.rename" severity="secondary"></p-button>
                <div *ngIf="!isFolderName(dialogControl.rename.file.name) && getFileEnding(dialogControl.rename.file.name) != dialogControl.rename.fileEnding" i18n="@@filestore-table.dialog.rename.button.error" class="form-text p-error text-left">The file extension was changed from .{{dialogControl.rename.fileEnding}} to .{{getFileEnding(dialogControl.rename.file.name)}}</div>
            </div>

        </div>
    </ng-template>
</p-dialog>

<p-dialog [focusOnShow]="false" header="Change display name" i18n-header="@@filestore-table.dialog.change-display-name.title" [modal]="true"
    [style]="{ width: '25rem' }" [(visible)]="dialogControl.changeDisplayName.visible" *ngIf="dialogControl.changeDisplayName.visible">
    <div class="flex flex-column gap-2 mt-2">
        <input pInputText aria-describedby="username-help" [(ngModel)]="dialogControl.changeDisplayName.file.displayName" />
        <small i18n="@@filestore-table.dialog.changeDisplayName.text" class="mt-1">
            Please enter the new display name
        </small>
    </div>
    <ng-template #footer>
        <div class="w-full flex justify-content-between">
            <div>
                <p-button (onClick)="dialogControl.changeDisplayName.file = null; dialogControl.changeDisplayName.visible=false"
                    label="Cancel" i18n-label="@@filestore-table.dialog.changeDisplayName.button.cancel"
                    severity="secondary"></p-button>
            </div>
            <div class="text-right">
                <p-button (onClick)="onChangeDisplayName()" label="Change display name"
                    i18n-label="@@filestore-table.dialog.change-display-name.button.changeDisplayName" severity="primary"></p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>

<p-dialog [focusOnShow]="false" header="Change alternative text" i18n-header="@@filestore-table.dialog.altText.title" [modal]="true"
          [style]="{ width: '25rem' }" [(visible)]="dialogControl.altText.visible" *ngIf="dialogControl.altText.visible">
    <div class="flex flex-column gap-2 mt-2">
        <label i18n="@@filestore-table.dialog.altText.label" class="sr-only">Alternative text</label>
        <textarea pTextarea rows="5" [(ngModel)]="dialogControl.altText.file.altText" ></textarea>
        <small i18n="@@filestore-table.dialog.altText.text" class="mt-1">
            Please enter the alternative text
        </small>
    </div>
    <ng-template #footer>
        <div class="w-full flex justify-content-between">
            <div>
                <p-button (onClick)="dialogControl.altText.file = null; dialogControl.altText.visible=false"
                          label="Cancel" i18n-label="@@filestore-table.dialog.altText.button.cancel"
                          severity="secondary"></p-button>
            </div>
            <div class="text-right">
                <p-button (onClick)="onChangeFileAltText()" label="Accept" i18n-label="@@filestore-table.dialog.altText.button.accept" severity="secondary"></p-button>
            </div>

        </div>
    </ng-template>
</p-dialog>

<p-drawer [(visible)]="bottomActionMenuOpen" position="bottom" *ngIf="bottomActionMenuOpen"
    styleClass="h-auto">
    <ng-template #header>
        <div class="flex align-items-center gap-2">
            <div class="text-secondary font-bold">{{ selectedContextMenuFile.name }}</div>
        </div>
    </ng-template>
    <ng-template #content>
        <p-menu [model]="contextMenuOptions" styleClass="w-full border-none">
            <ng-template #item let-item>
                <a pRipple class="flex align-items-center p-menuitem-link border-bottom-1 border-200 drawerMenutItemPadding">
                    <span [class]="item.icon"></span>
                    <span class="ml-2">{{ item.label }}</span>

                    <span *ngIf="item.shortcut"
                        class="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">
                        {{ item.shortcut }}
                    </span>
                </a>
            </ng-template>
        </p-menu>
    </ng-template>

</p-drawer>
